


































































































































/** @format */

import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';

import {
  TEMPORARY_PARKING_CHARGING_RULE_CREATE,
  TEMPORARY_PARKING_CHARGING_RULE_DETAIL,
  TEMPORARY_PARKING_CHARGING_RULE_EDIT
} from '../router-names';
import Utils from '@/utils/common';
import { DictIssuedStatus } from '@/types/common/dictionaries';
import { loadAllRulesList, updateStatus } from '@/api/parking-lot-management';

@Component({
  name: 'temporaryParkingChargingRule',
  components: {
    ParkingLotSearch
  }
})
export default class temporaryParkingChargingRule extends Mixins(TableMixin, TableWidthMixin) {
  // 计费规则类型
  billingWayOp: IOption[] = Utils.toLabelVal(
    this.$store.state.dictionaries.allDictionaries.cp_base_rule_original_billing_way
  );
  getbillingWayOp(value) {
    let a = [];
    if (value) {
      a = _.filter(this.billingWayOp, function(o) {
        return o.value == value;
      });
      return a.length > 0 ? a[0].label : '--' || '--';
    }
    return '--';
  }
  DictIssuedStatus = DictIssuedStatus;

  filterParam = {
    parkIds: [],
    feeName: '',
    billingWays: ''
  };

  tableLoading = false;
  tableData: any[] = [];
  get tableColums() {
    return [
      {
        title: '序号',
        width: 70,
        dataIndex: 'name',
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'textEllipse' }
      },
      {
        title: '计费规则名称',
        dataIndex: 'feeName',
        width: 180,
        scopedSlots: { customRender: 'textEllipse' }
      },
      {
        title: '计费类型',
        dataIndex: 'billingWay',
        width: 180,
        // customRender: function(val: any) {
        //   if (val === '0') {
        //     return '按时计费';
        //   } else if (val === '1') {
        //     return '分段计费';
        //   } else if (val === '2') {
        //     return '分时计费';
        //   } else if (val === '3') {
        //     return '按次计费';
        //   } else if (val === '4') {
        //     return '(新)按时计费';
        //   } else if (val === '5') {
        //     return '(江西体育局)按时计费';
        //   }
        // }
        scopedSlots: { customRender: 'billingWay' }
      },
      {
        title: '节假日模式',
        dataIndex: 'datePatternName',
        width: 140
      },
      {
        title: '规则描述',
        dataIndex: 'remarks',
        scopedSlots: { customRender: 'textEllipseRemark' },
        width: 240
      },
      {
        title: '状态',
        dataIndex: 'isEffectName',
        width: 140
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 260,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }

  async mounted() {
    this.fetchTableData();
  }

  clear({ defaultParkIdList }) {
    this.filterParam = {
      parkIds: defaultParkIdList,
      feeName: '',
      billingWays: ''
    };
    this.fetchTableData(true);
  }

  handleSearch() {
    this.fetchTableData(true);
  }

  async fetchTableData(resetPage?: boolean) {
    // 是否重置页数
    if (resetPage) {
      this.current = 1;
    }
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const { status, msg, code, data = {} } = await loadAllRulesList({
        ...this.filterParam,
        parkIds: this.filterParam.parkIds.join(','),
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { pageSize, currPage, totalPage, totalNum, datas = [], total } = data;
      this.total = Number(totalNum);
      if (datas.length > 0) {
        this.tableData = datas;
      } else {
        this.tableData = [];
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  addRuleTemp() {
    this.$router.push({
      name: TEMPORARY_PARKING_CHARGING_RULE_CREATE,
      query: { type: 'add' }
    });
  }

  toDetail(row: any, type: string) {
    switch (type) {
      case 'detail':
        this.$router.push({
          name: TEMPORARY_PARKING_CHARGING_RULE_DETAIL,
          query: {
            type: 'detail',
            id: row.id,
            billingWay: row.billingWay,
            ruleId: row.ruleId
          }
        });
        break;
      case 'edit':
        this.$router.push({
          name: TEMPORARY_PARKING_CHARGING_RULE_EDIT,
          query: {
            type: 'edit',
            id: row.id,
            billingWay: row.billingWay,
            ruleId: row.ruleId
          }
        });
        break;
      default:
        break;
    }
  }

  // 计费规则状态更新（生效、失效、删除）
  async opStatus(id: string, type: string) {
    let status = '';
    switch (type) {
      case 'start':
        status = '1';
        break;
      case 'stop':
        status = '0';
        break;
      case 'delete':
        status = 'remove';
        break;
      default:
        break;
    }
    if (status) {
      try {
        const { msg } = await updateStatus({ id, status });
        this.$message.success(msg || '操作成功');
        this.fetchTableData();
      } catch (error) {
        this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      }
    }
  }
}
